import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { useSelector } from 'react-redux';

import { IOfferSummaryInfoItemProps } from '../../../../../components/OfferSummaryInfo';
import { LandStatus } from '../../../../../components/additional_features/locales';
import { offerSelector } from '../../../../../selectors';
import { getLandAreaUnitType } from '../../../../../utils/offer_helpers';
import { getOfferType, isSuburban } from '../../../../../utils/offer_type';
import { useSummaryInfoBuildingProps } from '../../OfferSummaryInfoBuilding/hooks/useSummaryInfoBuildingProps';

export interface IUseSummaryInfoSuburbanPropsResponse {
  rightGroup: boolean;
  summaryInfoItems: IOfferSummaryInfoItemProps[];
}

export const useSummaryInfoSuburbanProps = (): IUseSummaryInfoSuburbanPropsResponse | null => {
  const offer = useSelector(offerSelector);

  const buildingProps = useSummaryInfoBuildingProps();

  const offerType = getOfferType(offer);

  const isSuburbanOffer = isSuburban(offerType);

  if (!isSuburbanOffer) {
    return null;
  }

  const summaryInfoItems: IOfferSummaryInfoItemProps[] = [];

  if (offer.land && offer.land.area) {
    summaryInfoItems.push({
      name: 'Площадь',
      value: `${numberToPrettyString(Number(offer.land.area))} ${getLandAreaUnitType(offer.land)}`,
    });
  }

  if (offer.land && offer.land.status) {
    summaryInfoItems.push({
      name: 'Статус участка',
      value: LandStatus[offer.land.status],
    });
  }

  if (!summaryInfoItems.length) {
    return null;
  }

  return {
    rightGroup: Boolean(buildingProps),
    summaryInfoItems,
  };
};
